export default __webpack_public_path__ + "static/media/linkedIn.6739f369.svg";